import React from 'react';
import { Box, Button, VStack, HStack } from '@chakra-ui/react';
import { getTranslations } from '../translations';

const Controls = ({
    isActive,
    isPaused,
    startTimer,
    togglePause,
    resetTimer,
    saveCurrentConfig,
    isDarkMode
}) => {
    const t = getTranslations();

    return (
        <Box w="100%" mt={isActive ? 2 : 8}>
            {!isActive ? (
                <VStack spacing={4}>
                    <Button
                        size="md"
                        colorScheme="blue"
                        variant="outline"
                        borderWidth="2px"
                        onClick={saveCurrentConfig}
                        w="full"
                        borderRadius="xl"
                        _hover={{ bg: isDarkMode ? 'blue.900' : 'blue.50' }}
                    >
                        {t.save}
                    </Button>
                </VStack>
            ) : (
                <HStack spacing={4}>
                    <Button
                        size="lg"
                        colorScheme={isPaused ? "green" : "yellow"}
                        onClick={togglePause}
                        w="full"
                        h="60px"
                        fontSize="xl"
                        borderRadius="xl"
                        boxShadow="lg"
                        _hover={{ transform: 'translateY(-2px)' }}
                    >
                        {isPaused ? t.resume : t.pause}
                    </Button>
                    <Button
                        size="lg"
                        colorScheme="red"
                        variant="outline"
                        onClick={resetTimer}
                        w="full"
                        h="60px"
                        fontSize="xl"
                        borderRadius="xl"
                        boxShadow="lg"
                        _hover={{ bg: isDarkMode ? 'red.900' : 'red.50' }}
                    >
                        {t.reset}
                    </Button>
                </HStack>
            )}
        </Box>
    );
};

export default Controls;
